import UserEventAPI from './api'
import { objectToCamelCase, objectToSnakeCase } from '../utils'
import options from './options'

export default class UserEvent {
  static options = options
  static api = UserEventAPI.create(UserEvent)
  static readOnlyFields = ['id']

  constructor({
    id = '',
    user = null,
    eventType = '',
    occurredAt = null,
    verificationAttempts = '',
    verificationAttemptOccurredAt = null,
    canAttempt = null,
    request = null,
    currentStep = null,
  } = {}) {
    Object.assign(this, {
      id,
      user,
      eventType,
      occurredAt,
      verificationAttempts,
      verificationAttemptOccurredAt,
      canAttempt,
      request,
      currentStep,
    })
  }

  static create(opts) {
    return new UserEvent(opts)
  }

  static fromAPI(json = {}) {
    return new UserEvent(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(userEvent, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach((field) => {
        data[field] = userEvent[field]
      })
    } else {
      data = userEvent
    }

    //
    excludeFields = [...UserEvent.readOnlyFields, ...excludeFields]
    excludeFields.forEach((item) => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
}
